import vue from 'vue'

const {get, post} = vue.prototype.appServe

// 膜协会
// 分页查询协会
export function associationPage(data) {
  return post('/user/association/user/listAssociationByPage', data)
}

// 根据协会查询委员列表
export function listCommitteeByAssociation(data) {
  return post('/user/association/user/listCommitteeByAssociation', data)
}

// 将来之星
export function JLpageList(data) {
  return post('/user/td/star/pageList', data)
}

// 天大
// 天大详情
export function selectIntroduce(data) {
  return post('/user/td/selectIntroduce', data)
}

// 查询天大公司列表
export function companyPageList(data) {
  return post('/user/td/company/pageList', data)
}

// 查询天大人员列表
export function pageList(data) {
  return post('/user/td/student/pageList', data)
}

// banner广告接口
export function backend(data) {
  return post('harbor/platform/advertising/list', data)
}




// WEBPACK FOOTER //
// ./src/factory-api/tianda-and-guild.js